import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            title: '',
            hashtag: [],
            url: '',
            channelKey: '',
            files: [],
            item: [],
            hashTitle: '',
            content: '',
            channelInfo: '',
            recommends: [], //추천메거진
            display: 0,
            deleteItems: [],
            youtubeId: '',
            videoLink: '',
            channelUrl: ''
        }
    },
    validators: {
        title: function (value) {
            let msg = '1~12자 내로 입력해주세요.';
            return Validator.value(value)
                    .required('제목을 입력해주세요.')
        },
        hashtag: function (value) {
            let msg = '';
            return Validator.value(value)
                    .custom(
                            () => {
                                if (value.length < 1) {
                                    msg = '해시태그를 선택해 주세요.';
                                    return msg;
                                } else if (value.length > 5) {
                                    msg = '해시태그는 최대 5개까지 등록할 수 있습니다.';
                                    value.length = 5;
                                    return msg;
                                }
                            })
        },
        url: function (value) {
            return Validator.value(value)
                    .required('URL을 입력해주세요.')
                    .regex('^.*(youtu.be\\/|v\\/|u\\/\\w\\/|embed\\/|watch\\?v=|&v=)([^#&?]*).*', 'URL을 입력해주세요.')
        },
        youtubeId: function (value) {
            return Validator.value(value)
                    .required('URL을 입력해주세요.')

        },
        content: function (value) {
            return Validator.value(value)
                    .required('내용을 입력해주세요.')
        },
        // channelInfo: function (value) {
        //     return Validator.value(value)
        // },
        channelInfo: function (value) {
            return Validator.value(value)
                .required("채널 소개를 입력해주세요.")
                .custom(() => {
                    let remove = value.replace(/(<([^>]+)>)/gi, "");
                    remove = remove.replace(/&nbsp;/gi, "");
                    remove = remove.replace(/\s/g, "");
                    if (util.isEmpty(remove)) {
                        return "채널 소개를 입력해주세요.";
                    }
                });
        },
        display: function (value) {
            return Validator.value(value)
        },
        recommends: function (value) {
            return Validator.value(value)
        },
        channelKey: function (value) {
            return Validator.value(value)
                    .required('채널을 선택해주세요.')
        },
        hashTitle: function (value) {
            let msg = '1 ~ 8자로 입력해주세요.';
            return Validator.value(value)
                    .required('제목을 입력해주세요.')
                    .maxLength(8, msg)
        },
        deleteItems: function (value) {
            return Validator.value(value)
        },
        files: function (value) {
            return Validator.value(value)
                .required('이미지를 업로드하세요.')
        },
        channelUrl: function (value){
            let msg = 'URL 주소 형식이어야 합니다.';
            return Validator.value(value).url(msg)
        }
    },
    methods: {},
    computed: {}
}
